export const nameRegex = '[a-zA-Z ]{1,}';
export const emailRegex = '^[A-Za-z0-9_%+-.]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$';
export const numericRegex = '[0-9]{1,}'